import {
  PROJECTMILESTONE,
  TASK_REQUEST,
  request,
  success,
  failure,
  PROJECT_BACKLOG,
} from "./utilities";
import {
  fetchProjectMilestones,
  CreateTaskInMilestone,
  fetchMilestonesTask,
  startSprintApi,
  completeSprintIfTasksCompletedActionApi,
  getAllSprintsWithoutStartSprintApi,
  moveSprintTasksApi,
  filterTaskByMilesoneApi,
  userSelectedMileStoneApi,
} from "../api";
import { APP_SETTINGS } from "../../config";
import { GetRequest, PostRequest } from "../api/genericApiCalls";

export function getFilterTaskMilestones(projectId, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_BACKLOG.FILTER_TASK_BY_MILESTONE_REQUEST));
    filterTaskByMilesoneApi(projectId, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECT_BACKLOG.FILTER_TASK_BY_MILESTONE_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              PROJECT_BACKLOG.FILTER_TASK_BY_MILESTONE_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_BACKLOG.FILTER_TASK_BY_MILESTONE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getProjectMilestones(projectId, token) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.GET_PROJECT_MILESTONE_REQUEST));

    return fetchProjectMilestones(projectId, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.GET_PROJECT_MILESTONE_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.GET_PROJECT_MILESTONE_FAILURE,
              res.data.message
            )
          );
        }
        return res;
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.GET_PROJECT_MILESTONE_FAILURE,
            error?.response?.data?.title || error.message
          )
        );
        throw error;
      }
    );
  };
}

export function getProjectMilestonesSelectList(projectId, token) {
  return (dispatch) => {
    dispatch(
      request(PROJECTMILESTONE.GET_PROJECT_MILESTONES_SELECTLIST_REQUEST)
    );
    var path =
      APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.GetMilestoneSelectList +
      "?projectId=" +
      projectId;
    PostRequest(path, projectId, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.GET_PROJECT_MILESTONES_SELECTLIST_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.GET_PROJECT_MILESTONES_SELECTLIST_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.GET_PROJECT_MILESTONES_SELECTLIST_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function addProjectMilestone(data, token, moveToNext) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.ADD_PROJECT_MILESTONE_REQUEST));
    var path =
      APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.addProjectMilestone;
    PostRequest(path, data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.ADD_PROJECT_MILESTONE_SUCCESS,
              res.data.data
            )
          );
          if (moveToNext) moveToNext(res);
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.ADD_PROJECT_MILESTONE_FAILURE,
              res.data.message
            )
          );
          if (moveToNext) moveToNext(res);
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.ADD_PROJECT_MILESTONE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function CreateTaskInMilestones(
  data,
  token,
  Notification,
  responseErrorFunc
) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.CREATE_TASK_IN_MILESTONE_REQUEST));
    CreateTaskInMilestone(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.CREATE_TASK_IN_MILESTONE_SUCCESS,
              res.data.data
            )
          );

          if (Notification) {
            Notification(res.data.message, "success", res);
          }

          if (responseErrorFunc) {
            responseErrorFunc(false);
          }
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.CREATE_TASK_IN_MILESTONE_FAILURE,
              res.data.message
            )
          );

          if (Notification) {
            Notification(res.data.message, "error", res);
          }

          if (responseErrorFunc) {
            responseErrorFunc(true);
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.CREATE_TASK_IN_MILESTONE_FAILURE,
            error?.response?.data?.title || error.message
          )
        );

        if (Notification) {
          Notification(
            error?.response?.data?.title ||
              error.message ||
              "An error occurred",
            "error",
            error
          );
        }

        if (responseErrorFunc) {
          responseErrorFunc(true);
        }
      }
    );
  };
}

export function UpdateTaskInMilestones(data, token, info, Notification) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.EDIT_TASK_IN_MILESTONE_REQUEST));
    CreateTaskInMilestone(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.EDIT_TASK_IN_MILESTONE_SUCCESS,
              res.data.data,
              info
            )
          );

          if (Notification) {
            Notification(res.data.message, "success");
          }
          // Update task in kanban
          dispatch(
            success(TASK_REQUEST.EDIT_TASK_SUCCESS, res.data.data, null)
          );

          // Show success notification
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.EDIT_TASK_IN_MILESTONE_FAILURE,
              res.data.message
            )
          );

          // Show error notification
          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.EDIT_TASK_IN_MILESTONE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );

        // Show error notification
        if (Notification) {
          Notification(
            error.response?.data?.title || error.message || "An error occurred",
            "error"
          );
        }
      }
    );
  };
}

export function FetchTaskInMilestones(data, token, info, callback) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_REQUEST));

    fetchMilestonesTask(data, token, info).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_SUCCESS,
              res.data.data,
              info
            )
          );
          if (callback) callback(res.data);
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_FAILURE,
              res.data.message
            )
          );
          if (callback) callback(res.data);
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_FAILURE,
            error?.response?.data?.title || error.message
          )
        );
        if (callback) callback({ status: 0, error });
      }
    );
  };
}

export function FetchCommentOfTaskInMilestone(taskId, infoObject, token) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.GET_COMMENT_IN_TASK_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.getCommentOfTaskInMilestone}?taskId=${taskId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.GET_COMMENT_IN_TASK_SUCCESS,
              res.data.data,
              infoObject
            )
          );
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.GET_COMMENT_IN_TASK_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.GET_COMMENT_IN_TASK_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function SaveCommentTaskInMilestone(reqObject, token, indexInfo) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.ADD_COMMENT_IN_TASK_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE
        .postCommentOfTaskInMilestone,
      reqObject,
      token
    ).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.ADD_COMMENT_IN_TASK_SUCCESS,
              res.data.data,
              indexInfo
            )
          );
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.ADD_COMMENT_IN_TASK_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.ADD_COMMENT_IN_TASK_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function DeleteCommentTaskInMilestone(commentId, info, token) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.DELETE_COMMENT_IN_TASK_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.deleteCommentOfTaskInMilestone}?commentId=${commentId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.DELETE_COMMENT_IN_TASK_SUCCESS,
              res.data.data,
              info
            )
          );
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.DELETE_COMMENT_IN_TASK_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.DELETE_COMMENT_IN_TASK_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function DeleteMilestoneAction(
  milestoneId,
  info,
  token,
  Notification,
  nextFunction
) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.DELETE_PROJECT_MILESTONE_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.deleteMilestone}?milestoneId=${milestoneId}`;
    GetRequest(path, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.DELETE_PROJECT_MILESTONE_SUCCESS,
              milestoneId,
              info
            )
          );

          if (Notification) Notification(res.data.message, "success");
          if (nextFunction) {
            nextFunction();
          }
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.DELETE_PROJECT_MILESTONE_FAILURE,
              res.data.message
            )
          );
          if (Notification) Notification(res.data.message, "error");
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.DELETE_PROJECT_MILESTONE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function ChangeTaskMilestoneAction(reqObject, token, info) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.CHANGE_TASK_MILESTONE_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.changeTaskMilestone,
      reqObject,
      token
    ).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTMILESTONE.CHANGE_TASK_MILESTONE_SUCCESS,
              res.data.data,
              info
            )
          );
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.CHANGE_TASK_MILESTONE_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function ChangeReleaseStatusAction(object, token) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.CHANGE_RELEASE_STATUS_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.changeReleaseStatus}`;
    PostRequest(path, object, token).then(
      (res) => {
        if (res.data.status === 1) {
          return;
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.CHANGE_RELEASE_STATUS_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.CHANGE_RELEASE_STATUS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function filterMilestoneAction(reqObject, token) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.FILTER_RELEASES_REQUEST));
    var path = APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.filterMileStones;
    PostRequest(path, reqObject, token).then(
      (res) => {
        if (res.data.status == 1) {
          dispatch(success(PROJECTMILESTONE.FILTER_RELEASES_SUCCESS));
          return;
        }
        dispatch(
          failure(PROJECTMILESTONE.FILTER_RELEASES_FAILURE, res.data.message)
        );
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.FILTER_RELEASES_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function startSprintAction(data, onSuccess, token, Notification) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.START_SPRINT_REQUEST));
    startSprintApi(data, token).then(
      (res) => {
        if (res.data.data) {
          dispatch(
            success(PROJECTMILESTONE.START_SPRINT_SUCCESS, data.milesStoneId)
          );
          onSuccess();
          if (Notification) {
            Notification(res.data.message, "success");
          }
        } else {
          dispatch(
            failure(PROJECTMILESTONE.START_SPRINT_FAILURE, res.data.message)
          );
          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.START_SPRINT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function completeSprintIfTasksCompletedAction(
  data,
  onFailure,
  token,
  onMoveTaskSuccess,
  Notification
) {
  return (dispatch) => {
    dispatch(
      request(PROJECTMILESTONE.COMPLETE_SPRINT_IF_TASKS_COMPLETED_REQUEST)
    );
    completeSprintIfTasksCompletedActionApi(data, token).then(
      (res) => {
        if (res.data.data) {
          dispatch(
            success(
              PROJECTMILESTONE.COMPLETE_SPRINT_IF_TASKS_COMPLETED_SUCCESS,
              data.milesStoneId
            )
          );
          // if (onFailure) {
          //   onFailure("res", res.data);
          // }
          if (onMoveTaskSuccess) onMoveTaskSuccess(res);

          if (Notification) {
            Notification(res.data.message, "success");
          }
        } else {
          onFailure(res);
          dispatch(
            failure(PROJECTMILESTONE.COMPLETE_SPRINT_IF_TASKS_COMPLETED_FAILURE)
          );
          // if (onFailure) {
          //   onFailure(res);
          // }
          if (onMoveTaskSuccess) onMoveTaskSuccess(res);
          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.COMPLETE_SPRINT_IF_TASKS_COMPLETED_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function getAllSprintsWithoutStartSprintAction(data, token) {
  return (dispatch) => {
    dispatch(
      request(PROJECTMILESTONE.GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_REQUEST)
    );
    getAllSprintsWithoutStartSprintApi(data, token).then(
      (res) => {
        if (res.data.status == 200) {
          dispatch(
            success(
              PROJECTMILESTONE.GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function moveSprintTasksAction(data, onSuccess, token) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.MOVE_SPRINT_TASKS_REQUEST));
    moveSprintTasksApi(data, token).then(
      (res) => {
        if (res.data.status == 200) {
          dispatch(
            success(PROJECTMILESTONE.MOVE_SPRINT_TASKS_SUCCESS, res.data.data)
          );
          onSuccess();
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.MOVE_SPRINT_TASKS_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.MOVE_SPRINT_TASKS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function userSelectedMileStoneAction(data, onSuccess, token) {
  return (dispatch) => {
    dispatch(request(PROJECTMILESTONE.USER_SELECTED_MILESTONE_REQUEST));
    userSelectedMileStoneApi(data, token).then(
      (res) => {
        if (res.data.status == 200) {
          dispatch(
            success(
              PROJECTMILESTONE.USER_SELECTED_MILESTONE_SUCCESS,
              res.data.data
            )
          );
          onSuccess();
        } else {
          dispatch(
            failure(
              PROJECTMILESTONE.USER_SELECTED_MILESTONE_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTMILESTONE.USER_SELECTED_MILESTONE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
